/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { FormItem_Input } from '../models/FormItem_Input';
import type { JobProgramMilestone } from '../models/JobProgramMilestone';
import type { JobTaskResponse } from '../models/JobTaskResponse';
import type { Programs } from '../models/Programs';
import type { Roles } from '../models/Roles';
import type { SendTasksRequest } from '../models/SendTasksRequest';
import type { TaskName } from '../models/TaskName';
import type { TaskResponse } from '../models/TaskResponse';
import type { TaskResponseWithFlatQuestions } from '../models/TaskResponseWithFlatQuestions';
import type { TaskSelectionAnswerOption } from '../models/TaskSelectionAnswerOption';
import type { TaskSet } from '../models/TaskSet';
import type { TaskStatus } from '../models/TaskStatus';
import type { TaskSubmitResponse } from '../models/TaskSubmitResponse';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class TaskRoutesRepository {
  /**
   * Get Guest Available Tasks
   * Get list of tasks that can be sent to a guest user based on their role.
   * @returns TaskSelectionAnswerOption Successful Response
   * @throws ApiError
   */
  public static taskRoutesGetGuestAvailableTasks({
    jobId,
    guestRole,
    authorization,
  }: {
    jobId: string,
    guestRole: Roles,
    authorization?: string,
  }): CancelablePromise<Array<TaskSelectionAnswerOption>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/jobs/{job_id}/tasks/guest-available-tasks',
      path: {
        'job_id': jobId,
      },
      headers: {
        'authorization': authorization,
      },
      query: {
        'guest_role': guestRole,
      },
      errors: {
        404: `Not Found`,
        422: `Validation Error`,
      },
    });
  }
  /**
   * Send Tasks
   * Sends tasks to guest user.
   * @returns any Successful Response
   * @throws ApiError
   */
  public static taskRoutesSendTasks({
    jobId,
    requestBody,
    authorization,
  }: {
    jobId: string,
    requestBody: SendTasksRequest,
    authorization?: string,
  }): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/api/jobs/{job_id}/tasks/send-tasks',
      path: {
        'job_id': jobId,
      },
      headers: {
        'authorization': authorization,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        422: `Validation Error`,
        500: `Internal Server Error`,
      },
    });
  }
  /**
   * Get Task By Name
   * Get a task by job id and task name. The resulting task is the composed attributes of all tasks of task_name across all programs associated with the job.
   * @returns TaskResponse Successful Response
   * @throws ApiError
   */
  public static taskRoutesGetTaskByName({
    jobId,
    taskName,
    authorization,
  }: {
    jobId: string,
    taskName: TaskName,
    authorization?: string,
  }): CancelablePromise<TaskResponse> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/jobs/{job_id}/tasks/get_task/{task_name}',
      path: {
        'job_id': jobId,
        'task_name': taskName,
      },
      headers: {
        'authorization': authorization,
      },
      errors: {
        404: `Not Found`,
        422: `Validation Error`,
      },
    });
  }
  /**
   * Get Tasks By Task Set
   * Get all tasks from a job's given task_set.
   * @returns JobTaskResponse Successful Response
   * @throws ApiError
   */
  public static taskRoutesGetTasksByTaskSet({
    jobId,
    taskSet,
    authorization,
  }: {
    jobId: string,
    taskSet: TaskSet,
    authorization?: string,
  }): CancelablePromise<Array<JobTaskResponse>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/jobs/{job_id}/tasks/get_by_task_set/{task_set}',
      path: {
        'job_id': jobId,
        'task_set': taskSet,
      },
      headers: {
        'authorization': authorization,
      },
      errors: {
        404: `Not Found`,
        422: `Validation Error`,
      },
    });
  }
  /**
   * Get Tasks By Job Program Id And Milestone
   * Get all tasks for a job program milestone.
   * @returns TaskResponse Successful Response
   * @throws ApiError
   */
  public static taskRoutesGetTasksByJobProgramIdAndMilestone({
    jobId,
    programKey,
    milestone,
    authorization,
  }: {
    jobId: string,
    programKey: Programs,
    milestone: JobProgramMilestone,
    authorization?: string,
  }): CancelablePromise<Array<TaskResponse>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/jobs/{job_id}/tasks/{program_key}/{milestone}',
      path: {
        'job_id': jobId,
        'program_key': programKey,
        'milestone': milestone,
      },
      headers: {
        'authorization': authorization,
      },
      errors: {
        404: `Not Found`,
        422: `Validation Error`,
      },
    });
  }
  /**
   * Defer Task
   * Defer task till a later time.
   * @returns any Successful Response
   * @throws ApiError
   */
  public static taskRoutesDeferTask({
    jobId,
    taskName,
    authorization,
  }: {
    jobId: string,
    taskName: TaskName,
    authorization?: string,
  }): CancelablePromise<(TaskName | null)> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/api/jobs/{job_id}/tasks/{task_name}/defer_task',
      path: {
        'job_id': jobId,
        'task_name': taskName,
      },
      headers: {
        'authorization': authorization,
      },
      errors: {
        422: `Validation Error`,
        500: `Internal Server Error`,
      },
    });
  }
  /**
   * Get Readonly Tasks
   * Get all tasks for a job detail page render.
   * @returns TaskResponseWithFlatQuestions Successful Response
   * @throws ApiError
   */
  public static taskRoutesGetReadonlyTasks({
    jobId,
    taskNames,
    authorization,
  }: {
    jobId: string,
    taskNames?: Array<TaskName>,
    authorization?: string,
  }): CancelablePromise<Array<TaskResponseWithFlatQuestions>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/jobs/{job_id}/tasks/readonly',
      path: {
        'job_id': jobId,
      },
      headers: {
        'authorization': authorization,
      },
      query: {
        'task_names': taskNames,
      },
      errors: {
        422: `Validation Error`,
      },
    });
  }
  /**
   * Update Task
   * Update a task by job id and task name.
   * @returns TaskSubmitResponse Successful Response
   * @throws ApiError
   */
  public static taskRoutesUpdateTask({
    jobId,
    taskName,
    requestBody,
    partialSave = false,
    authorization,
  }: {
    jobId: string,
    taskName: TaskName,
    requestBody: Array<FormItem_Input>,
    partialSave?: boolean,
    authorization?: string,
  }): CancelablePromise<TaskSubmitResponse> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/api/jobs/{job_id}/tasks/{task_name}',
      path: {
        'job_id': jobId,
        'task_name': taskName,
      },
      headers: {
        'authorization': authorization,
      },
      query: {
        'partial_save': partialSave,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        422: `Validation Error`,
      },
    });
  }
  /**
   * Update Task Status
   * Update a task's status.
   * @returns any Successful Response
   * @throws ApiError
   */
  public static taskRoutesUpdateTaskStatus({
    jobId,
    taskName,
    taskStatus,
    authorization,
  }: {
    jobId: string,
    taskName: TaskName,
    taskStatus: TaskStatus,
    authorization?: string,
  }): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/api/jobs/{job_id}/tasks/{task_name}/status/{task_status}',
      path: {
        'job_id': jobId,
        'task_name': taskName,
        'task_status': taskStatus,
      },
      headers: {
        'authorization': authorization,
      },
      errors: {
        404: `Not Found`,
        422: `Validation Error`,
      },
    });
  }
}
